import type { TFunction } from 'i18next'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'
import type { APIUser } from '../api'

const useUserAwareTranslation = (user?: APIUser, verbose?: boolean) => {
  if (verbose === true) {
    console.log('useUserAwareTranslation', user)
  }
  return useTranslationWithPrefix(
    _.isUndefined(user) ? '' : _.get(user, 'poiType', '').toLowerCase()
  )
}

const useTranslationWithPrefix = (prefix: string) => {
  const { t, i18n } = useTranslation()

  if (_.isUndefined(prefix) || _.isEmpty(prefix) || _.isEmpty(prefix.trim())) {
    return { t, i18n }
  }
  const cleanPrefix = prefix.trim()

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const tWithPrefix = (key: string, options?: any) => {
    const keyWithPrefix = `${cleanPrefix}.${key}`
    if (i18n.exists(keyWithPrefix)) {
      return t(keyWithPrefix, options)
    }
    if (!i18n.exists(key)) {
      //To force a missing key log of the keyWithPrefix if even the key doest not exists
      t(keyWithPrefix, options)
    }
    return t(key, options)
  }
  return { t: tWithPrefix as TFunction<'transalation', undefined>, i18n }
}

export { useTranslationWithPrefix, useUserAwareTranslation }
